import React from 'react';
import { Button } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

const PdfExportButton = ({
    contentRef,
    documentTitle = 'relatorio',
    disabled = false,
    variant = 'outline-secondary',
    className = '',
    pageStyle = '',
    onBeforeGetContent,
    onAfterPrint,
    children
}) => {
    const handlePrint = useReactToPrint({
        // O componente chamador decide qual parte da tela vira PDF.
        content: () => contentRef?.current,
        documentTitle,
        // O conteúdo de alguns relatórios fica fora da área visível enquanto está na tela.
        // Esta folha é copiada para o documento de impressão e permite que cada relatório
        // devolva seu conteúdo para o fluxo normal da página.
        pageStyle,
        // Opcionais: a tela pode se redesenhar para o papel antes da cópia (ex.: gráficos com
        // a largura da folha, que não se ajustam sozinhos depois de copiados) e voltar depois.
        onBeforeGetContent,
        onAfterPrint,
        removeAfterPrint: true
    });

    return (
        <Button
            variant={variant}
            className={className}
            onClick={handlePrint}
            disabled={disabled}
        >
            {children}
        </Button>
    );
};

export default PdfExportButton;
